export default "__VITE_ASSET__Bc0hFL2n__"